export const startWidth = '103px'
export const startHeight = '103px'

export const checkIsRightButtonNeeded = (
  screen,
  widgetIsOpen,
) => {
  const device = screen.width > 0 && screen.height > 0
  if (!device) {
    return true
  }
  return device && !widgetIsOpen
}

export const transitionSettingsLauncher = {
  timeout: 50
}

export const transitionSettingsContainer = {
  timeout: 50
}

export const detectUserLanguageOrDefault = language => {
  return language ?? 'en'
}

export const initialIframeSetting = Object.freeze({
  iframeSrc: '',
  questionnaireName: '',
  isLoaded: false,
  isIframeOpen: false,
  isQuestionnaireIframeOpened: false,
  opportunityToManualClose: true
})

export const initialImageModalSettings = Object.freeze({
  imageModalSrc: '',
  altText: ''
})

export const initialDatePickerSettings = Object.freeze({
  isShowSelectDate: false,
  selectDateUUID: '',
  currenDateValue: '',
  minDate: '',
  maxDate: '',
  dateFormat: '',
  calendarView: '',
  selectedPickerDate: false
})



export const setWidgetColor = color => ({
  backgroundColor: color,
})

export const checkWidgetSize = (classes, isFullScreenWidget) => {
  return isFullScreenWidget ? classes.fullScreenWidget : classes.widgetWrap
}
